'use strict';

angular.module('far.ui.readMoreBtn', [])
.directive('readMoreBtn', function($timeout) {
  return {
    restrict: 'A',
    link: function(scope, element, attr) {
      var minHeight = attr.readMoreBtn || 100,
          btnTemplate, btnElement, openElement, closeElement;

      $timeout(function() {
        if (element[0].clientHeight <= minHeight) {
          return;
        }

        btnTemplate =
         '<div class="read-more-btn">' +
           '<span class="read-more-btn__open">Читать далее</span>' +
           '<span class="read-more-btn__close">Свернуть</span>' +
         '</div>';

        btnElement = angular.element(btnTemplate);
        openElement = angular.element(btnElement[0].getElementsByClassName('read-more-btn__open'));
        closeElement = angular.element(btnElement[0].getElementsByClassName('read-more-btn__close'));

        openElement.on('click', function() {
          element.removeClass('closed');
        });
        closeElement.on('click', function() {
          element.addClass('closed');
        });

        element.addClass('closed with-animation');
        element.append(btnElement);
      });
    }
  }
});
